module.exports = __webpack_public_path__ + "static/media/logo-mon-test-auditif-couleur.7716ed2d.png";